import React, { useEffect, useState } from 'react'
import './homePage.css'
import { useDispatch, useSelector } from "react-redux";
import { clearError, getProduct, getProducts, getCreatedBy } from '../redux/actions/productAction';
import { useNavigate } from 'react-router-dom';
import company from "../utils/company";
import { GET_SELECT_PRODUCT_RESET } from '../redux/constants/productConstant';
import { loadUser } from '../redux/actions/userAction';
import Header from '../Components/Header';
// import {  } from '../../../backend/controlers/coaControler';


const HomePage = () => {

  const { error, loading, products } = useSelector((state) => state.getProducts)
  const { createds } = useSelector((state) => state.created)
  const { error: selectErr, loading: selectLoading, product: selectProduct, success: successSelect } = useSelector((state) => state.select)

  const dispatch = useDispatch();
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(getProducts())
    dispatch(getCreatedBy())

  }, [dispatch]);

  useEffect(() => {
    if (error) {
      alert(error)
      dispatch(clearError())
    }
    if (selectErr) {
      alert(selectErr)
      dispatch(clearError())
    }
    if (successSelect) {
      navigate('/create-coa')
      dispatch({ type: GET_SELECT_PRODUCT_RESET })
    }

  }, [error, selectErr, successSelect]);

  const [productId, setProductId] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [type, setType] = useState("");
  const [member, setMember] = useState("");
  const [memberId, setMemberId] = useState("");

  const formHandler = (e) => {
    e.preventDefault();


    // localStorage.removeItem('type');
    localStorage.setItem('type', type);
    localStorage.setItem('createMember', member);
    // localStorage.setItem('createMemberId', memberId);


    const companyDetails = company[companyId];
    localStorage.removeItem('company');

    if (companyDetails !== undefined) {
      var companyDetailsStr = JSON.stringify(companyDetails);
      localStorage.setItem('company', companyDetailsStr);
    }

    if (productId !== "") {
      dispatch(getProduct(productId, type))
    }


  };


  //  login --------------------------------------------------------------------------------
  useEffect(() => {
    dispatch(loadUser())
  }, [dispatch]);


  const { user, loading: userLoading, isAuthenticated } = useSelector(state => state.user)


  useEffect(() => {
    // dispatch(loadUser())

    if (!userLoading) {
      if (!isAuthenticated) {
        navigate("/login");
        console.log(userLoading, isAuthenticated)
      }
    }

    if (isAuthenticated === true) {
      navigate("/");
    }

  }, [dispatch, isAuthenticated]);


  return (
    <>
      <Header />
      <div className='topSpace formContainer '>



        <form action="" className='form' onSubmit={formHandler}>
          <div className='formBox'>
            <h4>Select Created By</h4>
            <select id="MemberSelect" required className='input' onChange={e => setMember(e.target.value)}>
              <option value="">SELECT</option>
              <option value="newMember" className='add-me'>Add New Member</option>
              {
                createds?.map(item => (
                  <option value={item.name}>{item.name}</option>
                ))
              }

              <option value="Sanchit">Sanchit</option>
              <option value="Akshat">Akshat</option>
            </select>
            <h4>Select</h4>
            <select id="fruitSelect" required className='input' onChange={e => setType(e.target.value)}>
              <option value="">SELECT</option>
              <option value="coa">COA</option>
              <option value="spec">Spec</option>
            </select>


            <h4>Select Company</h4>
            <select id="fruitSelect" required name="fruits" className='input' onChange={e => setCompanyId(e.target.value)}>
              <option value="">SELECT</option>
              <option value="new_company" className='add-me'>ADD NEW COMPANY</option>
              {
                !loading && company?.map((item, index) => (
                  <option value={index}>{item.name}</option>

                ))
              }
            </select>
            <h4>Select Product </h4>
            <select id="fruitSelect" required name="fruits" className='input' onChange={e => setProductId(e.target.value)}>
              <option value="">SELECT</option>
              <option value="new_product" className='add-me'>ADD NEW PRODUCT</option>

              {
                !loading && products?.map((item) => (
                  <option value={item._id}>{item.NAME}</option>
                ))
              }
            </select>
            <input type="submit" value={"Continue"} className='subBtn' />
          </div>
        </form>


      </div>
    </>

  )
}

export default HomePage